import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { rootStore } from './mobx/store'
import { inject, observer } from 'mobx-react'
import { ReactNotifications, Store } from 'react-notifications-component'

import { Page_settings } from './config/page_settings.js'
import Content from './components/content/content.jsx'
import Loading_bar from './components/control/loading_bar'
import CommonModal from './components/control/modal/modal'
import strings from './lang/strings'
import { API_URL, FORMAT, HEADER, IMP_CODE, RESULT_CODE } from './config/const'
import Header from './components/common/header'
import Footer from './components/common/footer'
import Sidebar from './components/sidebar/sidebar'
import PointPayModal from './components/control/modal/modal_point_pay'
import PointLackModal from './components/control/modal/modal_point_lack'
import PointUseModal from './components/control/modal/modal_point_use'
import PayConfirmModal from './components/control/modal/modal_pay_confirm'
import DailyModal from './components/control/modal/modal_daily'
import AlarmModal from './components/control/modal/modal_alarm'
import BuyOptionsModal from './components/control/modal/modal_buy_options'
import { randomString } from './helper/common'
import moment from 'moment'
import GlobalEffect from './helper/globalEffect.js'
class App extends React.Component {
  constructor(props) {
    super(props)
    window.IMP.init(`${IMP_CODE}`)
    this.intervalId = null;
    let uuid = localStorage.getItem('uuid') ?? randomString(32, 'alpha-digit')
    localStorage.setItem('uuid', uuid)
    // this.socket = io(SOCKET_URL, {auth: {token: rootStore.token, sessionID: uuid,}})
    this.toggleMobileSidebar = () => {
      this.setState(state => ({
        pageSidebarToggled: !state.pageSidebarToggled
      }))
    }
    this.closeMobileSidebar = () => {
      this.setState(state => ({
        pageSidebarToggled: false
      }))
    }
    this.handleSetPageBoxedLayout = (value) => {
      if (value === true) {
        document.body.classList.add('boxed-layout')
      } else {
        document.body.classList.remove('boxed-layout')
      }
    }
    this.toggleLoadingBar = isLoading => {
      this.setState({ pageLoading: isLoading })
    }
    this.addNotification = (title, message, type = 'success') => {
      Store.addNotification({
        title,
        message,
        type,
        insert: 'top',
        container: 'top-right',
        /*animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],*/
        dismiss: {
          duration: 5000,
          // onScreen: true
        }
      })
    }
    this.showModal = (title, text, okBtn, cancelBtn, cb) => {
      this.setState({
        modal: {
          show: true,
          title: title,
          text: text,
          okBtn: okBtn,
          cancelBtn: cancelBtn,
          cb: cb
        }
      })
    }
    this.showAlert = (text, cb, okBtn = strings.confirm) => {
      this.showModal(strings.alert, text, okBtn, '', cb)
    }
    this.showConfirm = (text, cb, okBtn = strings.ok, cancelBtn = strings.no) => {
      this.showModal(strings.question, text, okBtn, cancelBtn, cb)
    }
    this.showLogout = () => {
      this.showConfirm(strings.logout_q, function (val) {
        if (!val) return
        rootStore.signOut()
        // this.socket = io(SOCKET_URL, {auth: {token: '', sessionID: uuid,}})
        props.history.push('/dashboard')
      })
    }
    this.login = (mb, favBj, favWinee) => {
      rootStore.signIn(mb)
      rootStore.setFavBj(favBj)
      rootStore.setFavWinee(favWinee)
      this.readAlarm()
      // this.socket = io(SOCKET_URL, {auth: {token: mb.mb_token, sessionID: uuid,}})
    }
    this.showSignout = () => {
      const self = this
      self.showConfirm(strings.signout_q, function (val) {
        if (!val) return
        self.post('member/signout', {},
          () => {
            rootStore.signOut()
            // this.socket = io(SOCKET_URL, {auth: {token: '', sessionID: uuid,}})
            props.history.push('/dashboard')
          },
          false,
          err => {
            this.showAlert(err.msg)
          }
        )
      })
    }
    this.onLike = (mb, status, isBJ, cb) => {
      if (!rootStore.isSignedIn) {
        props.history.push('/login')
        return
      }
      if (rootStore.getMe.mb_id == mb.mb_id) return

      this.post('data/like', { to_uid: mb.mb_id, status: status },
        response => {
          let favList = isBJ ? rootStore.getFavBj : rootStore.getFavWinee
          if (status == 1) {
            favList = [...[mb], ...favList]
          } else {
            favList = favList.filter((item) => { return item.mb_id != mb.mb_id })
          }
          if (isBJ) {
            rootStore.setFavBj(favList)
          } else {
            rootStore.setFavWinee(favList)
          }
          cb?.(response)
        },
        false,
        err => {
          this.showAlert(err.msg)
        }
      )
    }
    this.getPoint = () => {
      if (!rootStore.isSignedIn) return
      this.post('member/getPoint', {},
        response => {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        },
        false,
        err => {
          this.showAlert(err.msg)
        }
      )
    }

    this.readAlarm = (alarm_id, cb) => {
      if (!rootStore.isSignedIn) return
      this.post('member/alarm_detail',  { alarm_id  : alarm_id },
        response => {
          rootStore.setAlarmCount(response.unread_count);
          cb?.(true, response)
        },
        false,
        err => {
          cb?.(false, err)
        }
      )
    }
    this.api = axios.create({
      baseURL: API_URL + '/api/',
      headers: {
        [HEADER.LANG]: 'ko'
      }
    })
    this.loadImage = (...url) => {
      return API_URL + '/' + url
    }
    this.post = async (uri, params, cb, showProgress = true, errCb = null) => {
      await this.request('POST', uri, params, cb, showProgress, errCb)
    }
    this.get = async (uri, params, cb, showProgress = true, errCb = null) => {
      await this.request('GET', uri, params, cb, showProgress, errCb)
    }
    this.delete = async (uri, params, cb, showProgress = true, errCb = null) => {
      await this.request('DELETE', uri, params, cb, showProgress, errCb)
    }
    this.request = async (method, uri, params, cb, showProgress = true, errCb = null) => {
      if (showProgress) {
        this.toggleLoadingBar(true)
      }
      this.api.defaults.headers.common[HEADER.AUTH_TOKEN] = this.props.rootStore.token
      this.api.defaults.responseType = 'json'

      try {
        let { data } = method !== 'GET' ? await this.api[method.toLowerCase()](uri, params) : await this.api.get(uri, { params })
        if (showProgress) {
          this.toggleLoadingBar(false)
        }

        if (Number(data.result) === RESULT_CODE.SUCCESS) {
          cb?.(data.data)
        } else {
          if (errCb != null) {
            errCb(data)
          } else {
            this.handleApiError(data)
          }
        }
      } catch (err) {
        console.log(err)
        if (showProgress) {
          this.toggleLoadingBar(false)
        }
        this.showAlert(err.message)
      }
    }
    this.download = async (method, uri, params, cb, showProgress = true) => {
      if (showProgress) {
        this.toggleLoadingBar(true)
      }
      this.api.defaults.headers.common[HEADER.AUTH_TOKEN] = this.props.rootStore.token
      this.api.defaults.responseType = 'blob'

      try {
        let response = method !== 'GET' ? await this.api[method.toLowerCase()](uri, params) : await this.api.get(uri, { params })
        if (showProgress) {
          this.toggleLoadingBar(false)
        }

        const filename = decodeURIComponent(response.headers['x-suggested-filename'])

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename) //or any other extension
        document.body.appendChild(link)
        link.click()

      } catch (err) {
        console.log(err)
        if (showProgress) {
          this.toggleLoadingBar(false)
        }
        this.showAlert(err.message)
      }
    }
    this.handleApiError = e => {
      if (Number(e.result) === RESULT_CODE.TOKEN_EXPIRED) {
        this.props.rootStore.signOut()
        this.props.history.replace('/login')
        return
      }
      this.showAlert(e.msg)
    }
    this.checkDailyPopup = () => {
      let popup_date = localStorage.getItem('popup_daily')
      let today = moment(this).format(FORMAT.DATE)
      if (today !== popup_date) {
        this.setState({ modalDaily: { show: true } })
      }
    }
    this.showPointPay = (cb) => {
      this.setState({ modalPay: { show: true, cb: cb } })
    }
    this.showPointLack = (type, point, cb) => {
      this.setState({ modalLack: { show: true, type: type, point: point, cb: cb } })
    }
    this.showPointUse = (name, point, cb) => {
      this.setState({ modalUse: { show: true, name: name, point: point, cb: cb } })
    }
    this.showPayConfirm = (point, vatFee, payer, sendSms, phone, cb) => {
      this.setState({ modalPayConfirm: { show: true, point: point, vatFee: vatFee, payer: payer, sendSms: sendSms, phone: phone, cb: cb } })
    }
    this.showAlarm = (alarm_id, is_alarm_page, cb) => {
      this.setState({ modalAlarm: { show: true, alarm_id : alarm_id, is_alarm_page:is_alarm_page, cb: cb } })
    }
    this.showBuyOption = (price1, price2, cb) => {
      this.setState({ modalBuyOption: { show: true,price1 : price1, price2: price2, cb: cb } })
    }

    this.state = {
      hasScroll: false,
      pageSidebarToggled: false,
      closeMobileSidebar: this.closeMobileSidebar,
      toggleMobileSidebar: this.toggleMobileSidebar,
      handleSetPageBoxedLayout: this.handleSetPageBoxedLayout,
      handleOnPoint: this.handleOnPoint,
      pageLoading: false,
      toggleLoadingBar: this.toggleLoadingBar,
      modal: {
        show: false,
        title: '',
        text: '',
        okBtn: '',
        cancelBtn: '',
        cb: null
      },
      modalPay: { show: false, cb: null },
      modalDaily: { show: false },
      checkDailyPopup: this.checkDailyPopup,
      showPointPay: this.showPointPay,
      showPointLack: this.showPointLack,
      showPointUse: this.showPointUse,
      showPayConfirm: this.showPayConfirm,
      showAlarm : this.showAlarm,
      readAlarm: this.readAlarm,
      showBuyOption : this.showBuyOption,
      showModal: this.showModal,
      showAlert: this.showAlert,
      showConfirm: this.showConfirm,
      showLogout: this.showLogout,
      login: this.login,
      showSignout: this.showSignout,
      onLike: this.onLike,
      getPoint: this.getPoint,
      addNotification: this.addNotification,
      post: this.post,
      get: this.get,
      delete: this.delete,
      download: this.download,
      loadImage: this.loadImage,
      isTokenFound: false,
      // socket: this.socket,
      showChat: false
    }
  }


  componentDidMount() {
    // window.Kakao.init(KAKAO_JS_KEY)
    // window.Kakao.isInitialized()
    window.addEventListener('scroll', this.handleScroll)
    // this.post('conf/get_conf', {type: 'sport_chat'},
    //   response => {
    //     this.setState({showChat: response.conf ?? 'ON'})
    //   }
    // )
    // this.socket.connect()
    // this.socket.on('connect', () => {this.socket.emit('connected')})
    // this.socket.on('user changed', users => {rootStore.setChatCnt(users.length)})
    // this.socket.on('chat show', show => {this.setState({ showChat: show })})
    this.state.readAlarm();
    this.intervalId = setInterval(() => {
      this.state.readAlarm();
    }, 30000); // 30초 = 30000ms

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  handleScroll = () => {
  }

  onModalPayClose = (res = null) => {
    this.setState(state => ({
      modalPay: { ...state.modalPay, show: false }
    }), () => {
      if (res) this.state.modalPay.cb?.(res)
    })
  }

  onModalLackClose = (res = null) => {
    this.setState(state => ({
      modalLack: { ...state.modalLack, show: false }
    }), () => {
      if (res) this.state.modalLack.cb?.(res)
    })
  }

  onModalUseClose = (res = null) => {
    this.setState(state => ({
      modalUse: { ...state.modalUse, show: false }
    }), () => {
      if (res) this.state.modalUse.cb?.(res)
    })
  }

  onModalPayConfirmClose = (res = null) => {
    this.setState(state => ({
      modalPayConfirm: { ...state.modalPayConfirm, show: false }
    }), () => {
      if (res) this.state.modalPayConfirm.cb?.(res)
    })
  }

  onModalAlarmClose = (res = null) => {
    this.setState(state => ({
      modalAlarm: { ...state.modalAlarm, show: false }
    }), () => {
      if (res) this.state.showAlarm.cb?.(res)
    })
  }

  onModalBuyOptionClose = (res = null) => {
    this.setState(state => ({
      modalBuyOption: { ...state.modalBuyOption, show: false }
    }), () => {
      if (res) this.state.showBuyOption.cb?.(res)
    })
  }

  onModalClose = res => {
    this.setState(state => ({
      modal: { ...state.modal, show: false }
    }), () => this.state.modal.cb?.(res))
  }

  render() {
    return (
        <Page_settings.Provider value={this.state}>
          <div className={
            'fade page-sidebar-fixed show page-container page-header-fixed ' +
            (this.state.pageSidebarToggled ? 'page-sidebar-toggled ' : '') +
            (this.state.hasScroll ? 'has-scroll ' : '')
          }>
            <GlobalEffect/>
            <ReactNotifications />
            <Header />
            {this.state.pageSidebarToggled && <Sidebar />}
            <Content />
            <Footer />
            <CommonModal {...this.state.modal} onModalClose={this.onModalClose} />
            <PointPayModal {...this.state.modalPay} toggle={() => { this.onModalPayClose() }} onProc={(mode, point, vatFee) => { this.onModalPayClose(0); this.props.history.push('/mypage/pay_do', { page: window.location.pathname, mode: mode, point: point, vatFee: vatFee }) }} onNobank={(point, vatFee, payer) => { this.onModalPayClose(); this.showPayConfirm(point, vatFee, payer); }} onConfirm={(value) => { this.onModalPayClose(value) }} />
            <PointLackModal {...this.state.modalLack} toggle={() => { this.onModalLackClose() }} onConfirm={(value) => { this.onModalLackClose(value) }} />
            <PointUseModal {...this.state.modalUse} toggle={() => { this.onModalUseClose() }} onConfirm={(value) => { this.onModalUseClose(value) }} />
            <PayConfirmModal {...this.state.modalPayConfirm} toggle={() => { this.onModalPayConfirmClose() }} />
            <AlarmModal {...this.state.modalAlarm} toggle={() => { this.onModalAlarmClose() }} />
            <BuyOptionsModal {...this.state.modalBuyOption} toggle={() => { this.onModalBuyOptionClose() }} />
            <DailyModal {...this.state.modalDaily} toggle={() => { this.setState({ modalDaily: { show: false } }) }} />
            {this.state.pageLoading && <Loading_bar />}
          </div>
        </Page_settings.Provider>
    )
  }
}

export default withRouter(inject('rootStore')(observer(App)))
